import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./index.scss";
import Loading from "../loading";

const ReusableModal = (props) => {
	const [currentProps, setCurrentProps] = useState(props);
	const [loading, setLoading] = useState(false);
	const [requestInformation, setRequestInformation] = useState(
		props.deleteData?.requestInformation?.value || ""
	);

	const handleHide = () => {
		if (!loading) {
			currentProps.close({}, null);
		}
	};

	const handleDelete = () => {
		setLoading(true);
		const deleteFunction = deleteData?.requestInformation
			? deleteData.deleteElement(deleteData._id, requestInformation)
			: deleteData.deleteElement(deleteData._id);
		deleteFunction
			.then((data) => {
				window.alert(data);
				currentProps.reloadData();
			})
			.catch((err) => {
				setLoading(false);
				window.alert(err);
			});
	};

	const handleOperation = () => {
		setLoading(true);
		currentProps.operationData
			.execute()
			.then((data) => {
				window.alert(data.message);
				currentProps.reloadData();
			})
			.catch((err) => {
				setLoading(false);
				window.alert(err);
			});
	};

	useEffect(() => {
		setCurrentProps(props);
	}, [props]);

	const {
		show,
		children,
		modalTitle,
		deleteData,
		big,
		size,
		errorMessage = "",
		operationData,
	} = currentProps;
	return (
		<Modal
			show={show}
			onHide={handleHide}
			size={deleteData && !big ? "" : size || "lg"}
			backdrop="static"
		>
			<Modal.Header closeButton>
				<Modal.Title>{deleteData?.modalTitle || modalTitle}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{show ? (
					operationData || deleteData || errorMessage ? (
						<div className="row">
							{!errorMessage && (
								<>
									<div className="col-12 text-center mb-3">
										<h5
											dangerouslySetInnerHTML={{
												__html: deleteData?.message || operationData?.title,
											}}
										/>
									</div>
									{deleteData?.requestInformation && (
										<div className="col-12 text-center mb-3">
											{deleteData.requestInformation?.label && (
												<label className="font-weight-bold no-select">
													{deleteData.requestInformation?.label}
												</label>
											)}
											<textarea
												className="form-control border-primary"
												name="requestInformation"
												type="text"
												disabled={loading}
												onChange={(event) =>
													setRequestInformation(event.target.value)
												}
												value={requestInformation}
											/>
										</div>
									)}
									{operationData?.subtitle && (
										<div className="col-12 text-center mb-3">
											<p
												dangerouslySetInnerHTML={{
													__html: operationData.subtitle,
												}}
											/>
										</div>
									)}
								</>
							)}
							{!loading ? (
								!errorMessage ? (
									<>
										<div className="col-6 text-center">
											<button
												className="btn btn-success"
												onClick={deleteData ? handleDelete : handleOperation}
											>
												<i className="fas fa-check"></i>&nbsp;Sí
											</button>
										</div>
										<div className="col-6 text-center">
											<button className="btn btn-danger" onClick={handleHide}>
												<i className="fas fa-times"></i>&nbsp;No
											</button>
										</div>
									</>
								) : (
									<div className="co-12 px-3">
										<h5 dangerouslySetInnerHTML={{ __html: errorMessage }} />
										<div className="text-right">
											<button
												className="btn btn-danger mt-4"
												onClick={handleHide}
											>
												<i className="fas fa-times"></i>&nbsp;Cerrar
											</button>
										</div>
									</div>
								)
							) : (
								<div className="col-12">
									<Loading />
								</div>
							)}
						</div>
					) : (
						React.cloneElement(children, { setParentLoading: setLoading })
					)
				) : (
					""
				)}
			</Modal.Body>
		</Modal>
	);
};

export default ReusableModal;
